'use client';

import { useTranslations } from 'next-intl';

import { LinkButton } from '../LinkButton';
import { SharePopover } from '../SharePopover';
import { S } from './JobActions.styles';

type JobActionsProps = {
  applyHref: string;
  shareUrl: string;
  shareTitle: string;
};

export const JobActions = ({ applyHref, shareUrl, shareTitle }: JobActionsProps) => {
  const t = useTranslations('Main');

  return (
    <S.Container data-guide-id="jobdetail-actions">
      <SharePopover url={shareUrl} title={shareTitle} />
      <LinkButton data-guide-id="jobdetail-apply-btn" href={applyHref} corner="rounded">
        {t('apply')}
      </LinkButton>
    </S.Container>
  );
};
